import React from 'react';
import { Moon, Sun, Monitor } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useTheme } from '@/context/ThemeContext';
import '@/components/primitives/primitives.css';

const OPTIONS = [
  { value: 'light', label: 'Light', Icon: Sun },
  { value: 'dark', label: 'Dark', Icon: Moon },
  { value: 'system', label: 'Match system', Icon: Monitor },
];

/** Theme picker: Light / Dark / Match system. The icon shows the theme in use. */
const ThemeToggle = () => {
  const { theme, preference, setTheme } = useTheme();
  const CurrentIcon = theme === 'dark' ? Moon : Sun;
  const current = OPTIONS.find((o) => o.value === preference)?.label || 'Match system';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="is-icon-btn"
          data-testid="theme-toggle"
          aria-label={`Theme: ${current}`}
          title={`Theme: ${current}`}
        >
          <CurrentIcon aria-hidden="true" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        <DropdownMenuLabel className="t-label" style={{ fontWeight: 600 }}>Theme</DropdownMenuLabel>
        <DropdownMenuRadioGroup value={preference} onValueChange={setTheme}>
          {OPTIONS.map(({ value, label, Icon }) => (
            <DropdownMenuRadioItem key={value} value={value} data-testid={`theme-option-${value}`}>
              <Icon className="w-4 h-4 mr-2" aria-hidden="true" />
              {label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ThemeToggle;
